export const ENV = process.env.REACT_APP_HOST_NAME;
export const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
let CLOUD9_API = process.env.REACT_APP_ADMIN_API_URL;

if (process.env.ENVIRONMENT === 'dev') {
    CLOUD9_API = process.env.REACT_APP_DEV_ADMIN_API_URL;
}

export { CLOUD9_API };
